'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dFull$002dReference from "./app.api.-General-Practice-User-Full-Reference.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55(evaluator$33) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$55__f_evaluator$13 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$55__f_evaluator$13 = evaluator$33;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$55() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$55__f_evaluator$13.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dFull$002dReference.$c_Lapp_api_GeneralPracticeUserFullReference) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$55, "app.api.DrugRequestsAcceptedListItem$$anon$55", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$55: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$55 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$55.js.map
